import { CodeCategory } from '../shared';
import { Entity } from '../entity';
import { JobType, Priority } from '../tenant';
import { Attachment } from '../shared/attachment';
import { DocumentLibrary } from '../shared/document.library';

export enum ComplianceQuestionType {
    Before = 'Before',
    During = 'During',
    After = 'After',
    Requirement = 'Requirement'
}

export enum ComplianceQuestionShowType {
    Categories = 'Categories',
    Codes = 'Codes'
}

export interface ComplianceQuestion extends Entity {

    type: ComplianceQuestionType;
    showType?: ComplianceQuestionShowType;
    key?: string;
    disabled?: boolean;
    jobTypes?: JobType[];
    jobPriorities?: Priority[];

    categories?: CodeCategory[];
    codes?: Entity[];
    checklistId?: string;
    complianceId?: string;

    completed?: boolean;

    confirmation?: boolean;

    attachment?: boolean;

    signature?: boolean;

    comment?: boolean;

    beforePhoto?: boolean;

    duringPhoto?: boolean;

    afterPhoto?: boolean;

    mandatory?: boolean;

    document?: DocumentLibrary;

    form?: boolean;
    formTemplate?: Entity;

    questionId?: string;

    forms?: Attachment[];
    updatedAt?: Date;
}


export interface Compliance extends Entity {
    system: boolean;
    customer?: Entity;
    questions: ComplianceQuestion[];
}

export interface ComplianceSummary extends Entity {
    customer?: Entity;
}




